var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor ideasoft-product-search" },
    [
      !_vm.channel
        ? _c(
            "section",
            [
              _c("a-result", {
                attrs: {
                  status: "warning",
                  title: "Ideasoft API not connected",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "extra",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-center",
                            },
                            [
                              _c(
                                "SupsisButton",
                                {
                                  attrs: { primary: "", ghost: "" },
                                  on: { click: _vm.gotoIdeasoft },
                                },
                                [_vm._v(" Connect to Ideasoft")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3553788062
                ),
              }),
            ],
            1
          )
        : [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "ideasoft-product-search-wrapper" }, [
              _c("div", { staticClass: "inputTitle" }, [
                _vm._v("Ürün Arama Terimi"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-editor-wrapper" },
                [
                  _c("TiptapEditor", {
                    attrs: {
                      "show-attributes": true,
                      "max-character-count": 100,
                      "show-emoji": false,
                      placeholder: "Ürün adı veya stok kodu",
                      rows: 1,
                    },
                    model: {
                      value: _vm.clone.searchTerm,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "searchTerm", $$v)
                      },
                      expression: "clone.searchTerm",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(1),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "active-connection" }, [
      _c("div", { staticClass: "logos", attrs: { "data-small": "true" } }, [
        _c("div", { staticClass: "logo1" }, [
          _c("img", {
            staticClass: "custom-block-logo",
            attrs: { src: "/static/img/supsis-logo2.png" },
          }),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
        _vm._v(" "),
        _c("div", { staticClass: "logo2" }, [
          _c("img", { attrs: { src: "/static/img/ideasoft.webp" } }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "active-connection-text" }, [
        _c("div", [
          _c("span", [_vm._v("Connected with")]),
          _vm._v(" "),
          _c("b", [_vm._v("Ideasoft")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "helper-text" }, [
      _c("div", { staticClass: "text-muted" }, [
        _c("i", { staticClass: "fas fa-info-circle" }),
        _vm._v(
          "\n                    Bu blok önce ürün adına göre arama yapar, sonuç bulamazsa stok koduna göre arama yapar.\n                "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }